import { render, staticRenderFns } from "./TravelPolicy.vue?vue&type=template&id=e436f55a&scoped=true&"
import script from "./TravelPolicy.vue?vue&type=script&lang=js&"
export * from "./TravelPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TravelPolicy.vue?vue&type=style&index=0&id=e436f55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e436f55a",
  null
  
)

export default component.exports